import classNames from "classnames";
import React from "react";
import { intl } from "../../i18n/TypedIntl";
import styles from "./chatClosedLine.css";

interface Props {
  status: "solved" | "unsolved";
  date: string;
  time: string;
}

type intlIdStatusClosedType = "conversation.status.solved" | "conversation.status.unsolved";

export const ChatClosedLine: React.SFC<Props> = ({ status, date, time }) => {
  const intlID = `conversation.status.${status}` as intlIdStatusClosedType;
  return (
    <div className={classNames(styles.event, styles[status])}>
      <div className={styles.date}>
        {date}
        {intl.formatMessage("conversation.event.at")}
        {time}{" "}
      </div>
      <div className={styles.status}>
        {intl.formatMessage("conversation.event.closedShort")}
        <b>{intl.formatMessage(intlID)}</b>
      </div>
    </div>
  );
};
